import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ReactComponent as ArrowIcon } from '../../../assets/Icons/arrow-accordion.svg';
import { ReactComponent as BehanceLogo } from '../../../assets/Icons/behance-logo.svg';

const ArrowIconStyled = styled(ArrowIcon)`
  width: 20px;
  height: 20px;
  rotate: 270deg;
  transition: transform 0.5s ease; /* Добавлено анимацию для поворота */
  // change color before whiteArrow prop
  & path {
    fill: ${props => (props.whiteArrow ? '#fff' : 'initial')}; /* Устанавливаем цвет иконки */
  }
`;

const BehanceLogoIcon = styled(BehanceLogo)`
  width: 20px;
  height: 20px;
  transition: all 0.5s ease-in-out;
  opacity: 0.5;
  filter: grayscale(100%); 
`;

const ButtonLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
  font-family: 'Inter-Regular';
  -webkit-tap-highlight-color: transparent;
  font-size: 20px;
  transition: all 0.5s ease;

  &:hover {
    background-color: #00A3FF;
    ${ArrowIconStyled} {
      transform: rotate(45deg);
    }
    
    ${BehanceLogoIcon} {
      opacity: 1;
      filter: grayscale(0%);
    }
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ButtonTitle = styled.span`
  margin-right: 32px;
  
  @media (max-width: 768px) {
    margin-right: 16px;
  }
`;


const ButtonWithArrow = ({ title, to, whiteArrow, behanceLogo }) => {
    return (
        <ButtonLink to={to} target="_blank" rel="noopener noreferrer">
            <ButtonTitle>{title}</ButtonTitle>
            {behanceLogo ? <BehanceLogoIcon /> : <ArrowIconStyled whiteArrow={whiteArrow} />}

        </ButtonLink>
    );
};

export default ButtonWithArrow;

